/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatLocationName } from '../../../../core/util/location';
import styled, { css } from 'styled-components';
import Picture from '../../../../components/SolvPatternLibrary/Picture';
import { getLogoImageObject } from '../../../../components/SolvPatternLibrary/Picture/util';

const UnstyledImgTag = styled.img``;

class ClinicLogo extends PureComponent {
  constructor(props) {
    super(props);
    this.imageObject = getLogoImageObject(this.props.location);
  }

  render = () => {
    const {
      location,
      width,
      alt,
      location: { displayNamePrimary, displayNameSecondary, city, state },
    } = this.props;
    const cityState = `${city}, ${state}`;
    const clinicName = `${displayNamePrimary}${
      displayNameSecondary ? `, ${displayNameSecondary}` : ''
    }`;

    return (
      <div
        className={this.props.className}
        itemScope
        itemProp="logo"
        itemType="https://health-lifesci.schema.org/ImageObject"
      >
        <meta itemProp="name" content={clinicName} />
        <meta itemProp="contentUrl" content={this.imageObject.fullRes} />
        <meta itemProp="contentLocation" content={cityState} />
        <meta itemProp="Description" content={`Logo of ${clinicName}, (${cityState})`} />
        <Picture
          imageObject={this.imageObject}
          imgTag={this.props.customImgTag || UnstyledImgTag}
          width={width}
          itemProp="image"
          role="presentation"
          alt={alt || `${formatLocationName(location)} Logo`}
        />
      </div>
    );
  };
}

ClinicLogo.propTypes = {
  location: PropTypes.object.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  customImgTag: PropTypes.any,
};

ClinicLogo.defaultProps = {
  width: 91,
};

export default ClinicLogo;
